import { z } from "zod";

export const createTrialAccountSchema = z.object({
  accountName: z
    .string()
    .trim()
    .min(2, "Kontoname ist erforderlich")
    .max(120, "Kontoname ist zu lang"),
  ownerName: z
    .string()
    .trim()
    .min(2, "Name ist erforderlich")
    .max(120, "Name ist zu lang"),
  email: z
    .string()
    .trim()
    .pipe(z.email("Ungültige E-Mail-Adresse").max(200, "E-Mail ist zu lang")),
  password: z
    .string()
    .min(10, "Passwort muss mindestens 10 Zeichen haben")
    .max(200, "Passwort ist zu lang"),
  seats: z
    .number({ message: "Bitte geben Sie die Anzahl der Zugänge ein" })
    .int("Nur ganze Zahlen")
    .min(1, "Mindestens 1 Zugang")
    .max(500, "Maximal 500 Zugänge"),
  acceptLegal: z.boolean().refine((v) => v === true, {
    message:
      "Bitte akzeptieren Sie die AGB einschließlich AVV und Nutzungsbedingungen und bestätigen Sie die Kenntnisnahme der Datenschutzhinweise.",
  }),
});

export type CreateTrialAccountForm = z.infer<typeof createTrialAccountSchema>;
